import { render, staticRenderFns } from "./NewTimeline.vue?vue&type=template&id=f60c2074&scoped=true"
import script from "./NewTimeline.vue?vue&type=script&lang=js"
export * from "./NewTimeline.vue?vue&type=script&lang=js"
import style0 from "./NewTimeline.vue?vue&type=style&index=0&id=f60c2074&prod&scoped=true&lang=css"
import style1 from "./NewTimeline.vue?vue&type=style&index=1&id=f60c2074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60c2074",
  null
  
)

export default component.exports